export default "__VITE_ASSET__B_43y4ar__"